/**
 * D17 / D24 — "is this row a `.chain` that must not open?" (it Needs approval and still
 * points somewhere). Dependency-light on purpose: the pickers and the gate both ask it,
 * and the pickers must not pull the Approve dialog's module graph in to do so.
 */
import { isChainPointerRow } from '@papan/types'

export interface PendingPointerLike {
  id: string
  name: string
  /** The row's kind (a chain at a FILE lists as a file) — drawn that way in the dialogs. */
  isFolder?: boolean
  fileType?: string | null
  chainNeedsApproval?: boolean
  chainCanApprove?: boolean
  chainBroken?: boolean
}

/** A `.chain` that must not open: it Needs approval and still points somewhere. */
export function isPendingPointer(f: PendingPointerLike): boolean {
  return isChainPointerRow(f) && !!f.chainNeedsApproval && !f.chainBroken
}
